:host,
:host * {
	box-sizing: border-box;
}

.w2d-action-bar {
	border-top: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
	padding: var(--ace-primitive-spacing-normal) 0;
	width: 100%;

	&__headline {
		width: 100%;
	}

	&__content {
		align-items: flex-start;
		display: flex;
		flex-direction: column;
		gap: var(--ace-primitive-spacing-normal);
		justify-content: space-between;
		width: 100%;

		@include mq($desktop) {
			align-items: center;
			flex-direction: row;
		}
	}

	&__actions {
		display: flex;
		flex-direction: column;
		gap: var(--ace-primitive-spacing-normal);
		justify-content: flex-start;
		width: 100%;

		@include mq($tablet) {
			flex-direction: row;
		}

		@include mq($tablet) {
			flex-direction: row;
			justify-content: flex-end;
		}
	}
}
